import axios from 'axios'
import { errorHandler } from '../exports/error_management'
import { buildQuery } from '../exports/queryStringBuilder'

import { StorageCache } from '../exports/dataStorage'
const storageKey = 'ams-rpa-task-key'
const prefixKey = "ams-rpa-task-key";

const getSuffixKey = (obj) => `-${btoa(JSON.stringify(obj))}`;

const api = async (method, path, params) => axios[method](path, params)

const state = {
    item: null,
    query: '',
    items: [],
    filters: {},
    pagination: null,
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set_items(state, payload) {
        state.items = payload
    },
    set_pagination(state, payload) {
        state.pagination = payload
    },

    SET_FILTERS(state, payload) {
        state.filters = payload
    },

    SET_QUERY(state, payload) {
        state.filters = payload
    },
}

const actions = {
    async create(context, payload) {
        try {
            const results = await api('post', `rpa-task`, payload)
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_item', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.items },
                data,
                null
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, id) {
        try {
            await context.dispatch('fetchAll')
            context.commit(
                'set_item',
                context.state.items.find(x => x.id == id)
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(
        { commit },
        { query, filters, page: page_no, isforcedReload }
    ) {
        try {
            filters = filters || {};
            query = query || "";
      
            commit("SET_FILTERS", filters);
            commit("SET_QUERY", query);
      
            const obj = {
              page: page_no,
              filters,
              query,
            };
      
            isforcedReload = !!isforcedReload;
      
            const suffixKey = getSuffixKey(obj);
            const storageCache = new StorageCache(prefixKey, suffixKey);
            let value;
            let is_valid = false;
      
            if (isforcedReload) {
              is_valid = false;
            } else {
              const { is_valid: _is_valid, value: _value } = storageCache.getObject();
              is_valid = _is_valid;
              value = _value;
            }
      
            if (!is_valid) {
              page_no = parseInt(page_no) || 0;
              const result = await api('get', `rpa-task?q=${query}&page=${page_no}&${buildQuery(filters)}`);
              const data = result.data.success.data;
              storageCache.set(data);
              value = data;
              if (page_no == 0) {
                commit("set_items", data);
              }
            }
            if (page_no > 0) {
                const {
                data: _orders = [],
                current_page: page = 1,
                per_page: pageSize = 10,
                total = 0,
                } = value || {};
                commit("set_pagination", {
                page,
                pageSize,
                total,
                });
                commit("set_items", _orders);
            }
        } catch (err) {
            errorHandler(err);
        }
    },
    async updateBillPaymentEmailSenderOrder(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
             await api(
                'post',
                `rpa-task/update/display/order/`,
                payload
            )
            context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, payload) {
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `rpa-task/${payload.id}`,
                payload
            )
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_item', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.items },
                data,
                payload.id
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        try {
            await api('delete', `rpa-task/${id}`)
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_item', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.items },
                null,
                id
            )
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
